export default "__VITE_ASSET__Dlgcyqt0__"